export const POS_DEFAULT_TERMINAL_THEME = {
  headerColor: '#004646',
  canvasColor: '#ffffff',
  railColor: '#f1f5f9',
  borderColor: '#e2e8f0',
  accentColor: '#7cc000',
  summaryColor: '#6b6a68',
};

export const POS_CATEGORY_ICON_OPTIONS = [
  { value: 'Sparkles', label: 'Highlights' },
  { value: 'UtensilsCrossed', label: 'Allgemein' },
  { value: 'CookingPot', label: 'Cooking Pot' },
  { value: 'Soup', label: 'Soup' },
  { value: 'Salad', label: 'Salad' },
  { value: 'Sandwich', label: 'Starter / Snack' },
  { value: 'Pizza', label: 'Pizza' },
  { value: 'IceCreamCone', label: 'Dolci / Eis' },
  { value: 'CupSoda', label: 'Softdrink' },
  { value: 'Coffee', label: 'Coffee' },
  { value: 'Beer', label: 'Beer' },
  { value: 'Wine', label: 'Wine' },
  { value: 'Martini', label: 'Cocktail / Shot' },
  { value: 'BookOpen', label: 'Karte / Menü' },
  { value: 'TicketPercent', label: 'Gutschein' },
  { value: 'UsersRound', label: 'Bankett / Gruppe' },
];

export function normalizeCategoryAppearanceName(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

const EXACT_CATEGORY_PRESETS = {
  arbereshe: { icon: 'CookingPot', color: '#B9AAB3', backgroundColor: '#DED5D9' },
  zuppe: { icon: 'Soup', color: '#E47C00', backgroundColor: '#F0C58D' },
  antipasti: { icon: 'Sandwich', color: '#8FB9C9', backgroundColor: '#CEE0E5' },
  pasta: { icon: 'CookingPot', color: '#CDBA9A', backgroundColor: '#E5DAC9' },
  risotto: { icon: 'CookingPot', color: '#7C32EE', backgroundColor: '#B99AE9' },
  pizza: { icon: 'Pizza', color: '#B69CA7', backgroundColor: '#DCCFD4' },
  insalata: { icon: 'Salad', color: '#9CBC91', backgroundColor: '#D4E1CE' },
  insalatone: { icon: 'Salad', color: '#9CBC91', backgroundColor: '#D4E1CE' },
  dolci: { icon: 'IceCreamCone', color: '#BDAFB9', backgroundColor: '#DED7DB' },
  bibite: { icon: 'CupSoda', color: '#9CC4D5', backgroundColor: '#D4E5EA' },
  caffetteria: { icon: 'Coffee', color: '#789493', backgroundColor: '#C7D1CF' },
  birre: { icon: 'Beer', color: '#A8D0DB', backgroundColor: '#D8E9EC' },
  spritzer: { icon: 'Wine', color: '#EA3B92', backgroundColor: '#F0A8CA' },
  vini: { icon: 'Wine', color: '#762BE8', backgroundColor: '#BE97E8' },
  'cocktails and longdrinks': { icon: 'Martini', color: '#94BAC7', backgroundColor: '#D3E2E6' },
  shots: { icon: 'Martini', color: '#4D1CA3', backgroundColor: '#AA96C7' },
  spumanti: { icon: 'Wine', color: '#087C72', backgroundColor: '#98C5C0' },
};

const KEYWORD_CATEGORY_PRESETS = [
  { keywords: ['highlight', 'special'], icon: 'Sparkles', color: '#B9BBB4', backgroundColor: '#DDDCD6' },
  { keywords: ['fruhstuck', 'fruehstuck', 'breakfast'], icon: 'CookingPot', color: '#B9AAB3', backgroundColor: '#DED5D9' },
  { keywords: ['pizza'], icon: 'Pizza', color: '#B69CA7', backgroundColor: '#DCCFD4' },
  { keywords: ['pasta'], icon: 'CookingPot', color: '#CDBA9A', backgroundColor: '#E5DAC9' },
  { keywords: ['risotto'], icon: 'CookingPot', color: '#7C32EE', backgroundColor: '#B99AE9' },
  { keywords: ['antipast', 'vorspeise', 'starter'], icon: 'Sandwich', color: '#8FB9C9', backgroundColor: '#CEE0E5' },
  { keywords: ['insalat', 'salat'], icon: 'Salad', color: '#9CBC91', backgroundColor: '#D4E1CE' },
  { keywords: ['dolci', 'dessert', 'nachspeise', 'kuchen'], icon: 'IceCreamCone', color: '#BDAFB9', backgroundColor: '#DED7DB' },
  { keywords: ['suppe', 'soup', 'zuppe'], icon: 'Soup', color: '#E47C00', backgroundColor: '#F0C58D' },
  { keywords: ['bibite', 'softdrink', 'getrank', 'getraenk', 'wasser', 'saft'], icon: 'CupSoda', color: '#9CC4D5', backgroundColor: '#D4E5EA' },
  { keywords: ['kaffee', 'coffee', 'caff', 'tee'], icon: 'Coffee', color: '#789493', backgroundColor: '#C7D1CF' },
  { keywords: ['birre', 'bier', 'beer'], icon: 'Beer', color: '#A8D0DB', backgroundColor: '#D8E9EC' },
  { keywords: ['spritz', 'wine', 'wein', 'vini', 'spumanti', 'sekt'], icon: 'Wine', color: '#762BE8', backgroundColor: '#BE97E8' },
  { keywords: ['cocktail', 'longdrink'], icon: 'Martini', color: '#94BAC7', backgroundColor: '#D3E2E6' },
  { keywords: ['shot'], icon: 'Martini', color: '#4D1CA3', backgroundColor: '#AA96C7' },
  { keywords: ['bankett', 'banquet', 'event'], icon: 'UsersRound', color: '#D6C8B3', backgroundColor: '#EEE4D6' },
  { keywords: ['gutschein', 'voucher'], icon: 'TicketPercent', color: '#A5BAC4', backgroundColor: '#D7E2E7' },
  { keywords: ['menu', 'menue', 'speisekarte'], icon: 'BookOpen', color: '#ADC4CE', backgroundColor: '#DDE6EA' },
];

export function findDefaultCategoryAppearance(name) {
  const normalized = normalizeCategoryAppearanceName(name);
  if (!normalized) return null;

  if (EXACT_CATEGORY_PRESETS[normalized]) {
    return { ...EXACT_CATEGORY_PRESETS[normalized] };
  }

  const keywordMatch = KEYWORD_CATEGORY_PRESETS.find(({ keywords }) =>
    keywords.some((keyword) => normalized.includes(keyword)),
  );

  return keywordMatch ? {
    icon: keywordMatch.icon,
    color: keywordMatch.color,
    backgroundColor: keywordMatch.backgroundColor,
  } : null;
}
